import { getInvoiceViewStatus, INVOICE_STATUS } from '../../../component/Elements/table/InvoicesTable/constants'
import { APPEND_INVOICES, UPDATE_INVOICE_CANCELED, SET_INVOICES, SET_INVOICES_STATUS_FILTER, SET_INVOICES_TOTAL_LENGTH, SET_IS_INVOICE_CHANGE_EMAIL, SET_IS_INVOICE_CORRECTION, SET_SELECTED_INVOICE, SET_SELECTED_INVOICE_ORDER, SET_SHOW_INVOICE_BILLING_ADDRESS_MODAL, SET_SHOW_INVOICE_CANCEL_MODAL, SET_SHOW_INVOICE_DATA_MODAL, SET_SHOW_INVOICE_OPTIONS_MODAL, SET_SHOW_INVOICE_RESEND_EMAIL_INFO_MODAL, SET_SHOW_INVOICE_RESEND_EMAIL_MODAL, SET_UNPAID_INVOICES_COUNTER } from '../../actionTypes/invoice'

const initialState = {
	invoices: [],
	invoicesTotalLength: 0,
	unpaidInvoicesCounter: 0,
	statusFilter: [],
	selectedInvoice: null,
	selectedInvoiceOrder: null,
	modal: {
		showOptions: false,
		showInvoiceData: false,
		showBillingAddress: false,
		showInfoResendEmail: false,
		showResendEmail: false,
		showCancelInvoice: false,
	},
	isInvoiceChangeEmail: false,
	isInvoiceCorrection: false,
}

export function invoiceReducer (state = initialState, action) {
	switch (action.type) {
		case SET_INVOICES:
			return {
				...state,
				invoices: action.value,
			}
		case APPEND_INVOICES:
			return {
				...state,
				invoices: state.invoices.concat(...action.value),
			}
		case SET_INVOICES_TOTAL_LENGTH:
			return {
				...state,
				invoicesTotalLength: action.value,
			}
		case UPDATE_INVOICE_CANCELED: {
			const canceledInvoice = state.invoices.find(invoice => invoice.id === action.value.id)
			if (!canceledInvoice) return state
			const wasUnpaid = getInvoiceViewStatus(canceledInvoice) === INVOICE_STATUS.UNPAID
			return {
				...state,
				invoices: state.invoices.map(invoice => invoice.id === action.value.id ? { ...invoice, status: INVOICE_STATUS.CANCELED, statusChangedDate: action.value.date } : invoice),
				unpaidInvoicesCounter: wasUnpaid ? Math.max(state.unpaidInvoicesCounter - 1, 0) : state.unpaidInvoicesCounter,
			}
		}
		case SET_INVOICES_STATUS_FILTER:
			return {
				...state,
				statusFilter: action.value,
			}
		case SET_UNPAID_INVOICES_COUNTER:
			return {
				...state,
				unpaidInvoicesCounter: action.value,
			}
		case SET_SELECTED_INVOICE:
			return {
				...state,
				selectedInvoice: action.value,
			}
		case SET_SHOW_INVOICE_OPTIONS_MODAL:
			return {
				...state,
				modal: {
					...state.modal,
					showOptions: action.value,
				},
			}
		case SET_SHOW_INVOICE_DATA_MODAL:
			return {
				...state,
				modal: {
					...state.modal,
					showInvoiceData: action.value,
				},
			}
		case SET_SHOW_INVOICE_BILLING_ADDRESS_MODAL:
			return {
				...state,
				modal: {
					...state.modal,
					showBillingAddress: action.value,
				},
			}
		case SET_SHOW_INVOICE_RESEND_EMAIL_INFO_MODAL:
			return {
				...state,
				modal: {
					...state.modal,
					showInfoResendEmail: action.value,
				},
			}
		case SET_SHOW_INVOICE_RESEND_EMAIL_MODAL:
			return {
				...state,
				modal: {
					...state.modal,
					showResendEmail: action.value,
				},
			}
		case SET_IS_INVOICE_CHANGE_EMAIL:
			return {
				...state,
				isInvoiceChangeEmail: action.value
			}
		case SET_IS_INVOICE_CORRECTION:
			return {
				...state,
				isInvoiceCorrection: action.value,
			}
		case SET_SELECTED_INVOICE_ORDER:
			return {
				...state,
				selectedInvoiceOrder: action.value,
			}
		case SET_SHOW_INVOICE_CANCEL_MODAL:
			return {
				...state,
				modal: {
					...state.modal,
					showCancelInvoice: action.value,
				},
			}
		default:
			return state
	}
}
